import { useLoaded } from '../lib/useLoaded.ts';
import type { DataPort } from '../adapters/port.ts';

/**
 * El cumplimiento real: qué se prometió y qué se entregó.
 *
 * 🔴 Es la deuda más vieja del sistema. Lo primero que pidió Dirección fue «una
 * fecha cierta, porque si no no sé dónde estoy parado». El sistema aprendió a
 * comprometerla y NUNCA la midió — la vista existía desde la migración 0015 y
 * no la leía nadie. Comprometer sin medir es la mitad de la promesa, y es la
 * mitad fácil.
 *
 * Acá no se maquilla nada: si se entregó tarde, dice tarde, aunque haya sido
 * por tres minutos. Un tablero que sólo muestra los verdes no es un tablero.
 */
export function Cumplimiento({ port }: { port: DataPort }) {
  const c = useLoaded(() => port.compliance());
  if (c.kind !== 'ok') return null;
  const { porcentaje, aTiempo, tarde, medidos, proyectos } = c.value;

  const hora = (iso: string | null) => iso
    ? new Date(iso).toLocaleString('es-AR', {
        timeZone: 'America/Argentina/Buenos_Aires',
        day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hour12: false })
    : '—';

  return (
    <section className="cumpl">
      <div className="cumpl__head">
        <span className="eyebrow">Cumplimiento</span>
        <span className="panel__rule" />
      </div>

      <p className="lede">
        Qué se prometió y qué se entregó. La comparación es contra el reloj, sin interpretación.
      </p>

      {medidos === 0 ? (
        <p className="note">
          Todavía no hay ninguna entrega terminada, así que no hay cumplimiento que medir.
          Un sistema sin entregas no tiene 100%: no tiene porcentaje.
        </p>
      ) : (
        <>
          <div className="cumpl__resumen">
            <div className={'cumpl__gran ' + (porcentaje === 100 ? 'cumpl__gran--ok' : porcentaje !== null && porcentaje < 60 ? 'cumpl__gran--mal' : '')}>
              <strong>{porcentaje}%</strong>
              <span>de las entregas llegaron en fecha</span>
            </div>
            <div className="cumpl__chicos">
              <div><strong>{aTiempo}</strong><span>en fecha</span></div>
              <div><strong>{tarde}</strong><span>fuera de fecha</span></div>
              <div><strong>{medidos}</strong><span>medidas</span></div>
            </div>
          </div>

          <ol className="cumpl__lista">
            {proyectos.map((p) => (
              <li key={p.code} className={'cumpl__fila' + (p.cumplio === true ? ' cumpl__fila--ok' : p.cumplio === false ? ' cumpl__fila--mal' : '')}>
                <span className="cumpl__code mono">{p.code}</span>
                <span className="cumpl__estado">
                  {p.cumplio === null ? 'en curso' : p.cumplio ? 'en fecha' : 'fuera de fecha'}
                </span>
                <span className="cumpl__dato"><em>comprometido</em> {hora(p.comprometido)}</span>
                <span className="cumpl__dato"><em>entregado</em> {hora(p.entregado)}</span>
                <span className="cumpl__dato mono">
                  {p.realMin ?? '—'} min{p.estimadoMin ? ` / ${p.estimadoMin} previstos` : ''}
                </span>
              </li>
            ))}
          </ol>
        </>
      )}
    </section>
  );
}
